/**
 * Client-assigned identities — operation ids and component ids (ADR-025) — as RFC 4122 v4
 * UUIDs. `crypto.randomUUID` needs Safari 15.4 / Android WebView 92 (ADR-029 §2): the native
 * shells enforce those floors, and the `getRandomValues` fallback here is the belt to that
 * brace, so an edit never throws in a WebView where the sign-in just succeeded.
 */

/** An RFC 4122 v4 UUID from 16 random bytes (the version and variant bits stamped in). */
export function uuidV4(
  random: (bytes: Uint8Array) => Uint8Array = (bytes) => crypto.getRandomValues(bytes),
): string {
  const bytes = random(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** A fresh id: the platform's `randomUUID` where it exists, the fallback otherwise. */
export function newId(): string {
  return typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : uuidV4();
}
